/* eslint-disable max-len */
import React from 'react';
import { GRAY } from './styleConstants';

export default ({ size = 'medium', fillColor = GRAY }) => {
  if (size === 'small') {
    return (
      <div style={({ width: 11 })}>
        <svg width="11px" height="11px" viewBox="0 0 11 11" version="1.1">
          <g id="new_window_small" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <path
              d="M9,9 L2,9 L2,2 L5.5,2 L5.5,1 L2,1 C1.4475,1 1,1.4475 1,2 L1,9 C1,9.5525 1.4475,10 2,10 L9,10 C9.5525,10 10,9.5525 10,9 L10,5.5 L9,5.5 L9,9 Z"
              id="Path"
              fill={fillColor}
              fillRule="nonzero"
            />
            <polygon
              id="Path"
              fill={fillColor}
              fillRule="nonzero"
              points="6.30049075 1 6.30049075 2.05700264 8.19516799 2.05700264 3 7.25217063 3.74782937 8 8.94299736 2.80483201 8.94299736 4.69950925 10 4.69950925 10 1"
            />
          </g>
        </svg>
      </div>
    );
  }

  if (size === 'medium') {
    return (
      <div style={({ width: 19 })}>
        <svg
          width="19px"
          height="19px"
          viewBox="0 0 19 19"
          version="1.1"
        >
          <g id="new_window_medium" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <path
              d="M16.1111111,16.1111111 L2.88888889,16.1111111 L2.88888889,2.88888889 L9.5,2.88888889 L9.5,1 L2.88888889,1 C1.84527778,1 1,1.84527778 1,2.88888889 L1,16.1111111 C1,17.1547222 1.84527778,18 2.88888889,18 L16.1111111,18 C17.1547222,18 18,17.1547222 18,16.1111111 L18,9.5 L16.1111111,9.5 L16.1111111,16.1111111 Z"
              id="Path"
              fill={fillColor}
              fillRule="nonzero"
            />
            <polygon
              id="Path"
              fill={fillColor}
              fillRule="nonzero"
              points="11.1294828 1 11.1294828 2.96300491 14.6481691 2.96300491 5 12.611174 6.38882597 14 16.0369951 4.35183088 16.0369951 7.87051718 18 7.87051718 18 1"
            />
          </g>
        </svg>
      </div>
    );
  }

  return (
    <div style={({ width: 42 })}>
      <svg
        width="42px"
        height="42px"
        viewBox="0 0 42 42"
        version="1.1"
        title="This link opens a new window"
      >
        <g id="new_window" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <path
            d="M35,35 L7,35 L7,7 L21,7 L21,3 L7,3 C4.79,3 3,4.79 3,7 L3,35 C3,37.21 4.79,39 7,39 L35,39 C37.21,39 39,37.21 39,35 L39,21 L35,21 L35,35 Z"
            id="Path"
            fill={fillColor}
            fillRule="nonzero"
          />
          <polygon
            id="Path"
            fill={fillColor}
            fillRuule="nonzero"
            points="25 3 25 7 32.17 7 12.51 26.66 15.34 29.49 35 9.83 35 17 39 17 39 3"
          />
        </g>
      </svg>
    </div>
  );
};
